import { useQuery, useQueryClient } from "@tanstack/react-query";
import { SuperPageServices } from "../services/bedrock/SuperPageServices";
import { useSocialCoachSession } from "./useSocialCoachSession";

type UseSuperPageAssignmentsOverviewOptions = {
  enabled?: boolean;
};

export const useSuperPageAssignmentsOverview = (options?: UseSuperPageAssignmentsOverviewOptions) => {
  const { userId } = useSocialCoachSession();
  const queryClient = useQueryClient();
  const enabled = (options?.enabled ?? true) && !!userId;

  const { data: superPageAssignmentsOverview, isFetching } = useQuery({
    queryKey: ["superPageAssignmentsOverview", userId] as const,
    queryFn: () => SuperPageServices.getSuperPageAssignmentsOverview(),
    staleTime: 1000 * 60 * 5, // 5 minutes
    enabled,
  });

  const clearSuperPageAssignmentsOverviewCache = () => {
    queryClient.invalidateQueries({ queryKey: ["superPageAssignmentsOverview"] }).catch(console.error);
  };

  return {
    superPageAssignmentsOverview,
    isFetching,
    clearSuperPageAssignmentsOverviewCache,
  };
};
